<template>
    <div class="related-products" >
      RELATED PRODS
    </div>
</template>

<script>

const R = require("ramda");

var splitPlus = function(str, sep) {
  var a = str.split(sep);
  if (a[0] == "" && a.length == 1) return [];
  return a;
};
export default {
  name: "RelatedProducts",
  computed: {
    currentVariant: function() {
      return this.$store.getters.currentVariant;
    },
  }, 
};
</script>
<style lang="scss">
@import "../styles/settings.scss";


</style>
